import { render, staticRenderFns } from "./InvoiceTemplate.vue?vue&type=template&id=7c4a4b44&"
import script from "./InvoiceTemplate.vue?vue&type=script&lang=js&"
export * from "./InvoiceTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c4a4b44')) {
      api.createRecord('7c4a4b44', component.options)
    } else {
      api.reload('7c4a4b44', component.options)
    }
    module.hot.accept("./InvoiceTemplate.vue?vue&type=template&id=7c4a4b44&", function () {
      api.rerender('7c4a4b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/InvoiceTemplate.vue"
export default component.exports